import { useFeatureFlag } from '../../../../../hooks/useFeatureFlag';
import { FLAG_CLEANING_FEES } from '../../../../../utils/featureFlags';
// Feature flags the funnel steps depend on; null while they load.
export var useStepFlags = function () {
    var _a;
    var isCleaningFeesEnabled = useFeatureFlag(FLAG_CLEANING_FEES);
    if (isCleaningFeesEnabled === null) {
        return null;
    }
    return _a = {}, _a[FLAG_CLEANING_FEES] = isCleaningFeesEnabled, _a;
};
// A step behind a flag stays hidden while the flags load.
export var isStepEnabled = function (step, stepFlags) {
    return !!step && (!step.featureFlag || (stepFlags === null || stepFlags === void 0 ? void 0 : stepFlags[step.featureFlag]) === true);
};
export var getLastStepId = function (part, stepFlags) {
    return Math.max.apply(Math, Object.entries(part.steps)
        .filter(function (_a) {
        var step = _a[1];
        return isStepEnabled(step, stepFlags);
    })
        .map(function (_a) {
        var stepId = _a[0];
        return Number(stepId);
    }));
};
